import * as React from 'react';
import * as PopoverPrimitive from '@radix-ui/react-popover';
import { PopoverContentProps } from '@radix-ui/react-popover';
import { cn } from '../../../../utils';

const Popover = PopoverPrimitive.Root;

const PopoverTrigger = PopoverPrimitive.Trigger;

type PopoverAnchorProps = React.ComponentPropsWithoutRef<typeof PopoverPrimitive.Anchor> & {
  children?: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
};

const PopoverAnchor = React.forwardRef<React.ElementRef<typeof PopoverPrimitive.Anchor>, PopoverAnchorProps>(
  (props, ref) => <PopoverPrimitive.Anchor ref={ref} {...props} />,
);

PopoverAnchor.displayName = PopoverPrimitive.Anchor.displayName;

const PopoverContent = React.forwardRef<
  React.ElementRef<typeof PopoverPrimitive.Content>,
  React.ComponentPropsWithoutRef<typeof PopoverPrimitive.Content>
>(({ className, align = 'center', sideOffset = 4, ...props }, ref) => (
  <PopoverPrimitive.Portal>
    <PopoverPrimitive.Content
      ref={ref}
      align={align}
      sideOffset={sideOffset}
      className={cn(
        // eslint-disable-next-line max-len
        'z-50 w-72 rounded-md border bg-popover p-4 text-popover-foreground shadow-md outline-none data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2',
        className,
      )}
      {...props}
    />
  </PopoverPrimitive.Portal>
));

PopoverContent.displayName = PopoverPrimitive.Content.displayName;

/** Popover content version for menu items. Should have multiple items in fragment */
interface MenuPopoverContentProps extends React.PropsWithChildren {
  align?: PopoverContentProps['align'];
  className?: string;
  wrapperClassName?: string;
}

function MenuPopoverContent({ align, className, wrapperClassName, children }: MenuPopoverContentProps) {
  return (
    <PopoverContent className={cn(['mt-[12px] p-0 w-max min-w-32'], className)} align={align}>
      <div
        className={cn([
          'flex flex-col justify-start items-start',
          'child:w-[100%] child:px-4 child:py-2 hover:child:bg-muted child:justify-start',
          wrapperClassName,
        ])}
      >
        {children}
      </div>
    </PopoverContent>
  );
}

MenuPopoverContent.defaultProps = {
  align: 'center',
  className: undefined,
  wrapperClassName: undefined,
};

export { Popover, PopoverTrigger, PopoverContent, PopoverAnchor, MenuPopoverContent };
